import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "inline-flex w-full gap-1 rounded-lg bg-slate-100 p-1 sm:w-auto",
  role: "tablist",
  "aria-label": "日报阶段"
};
const _hoisted_2 = ["aria-selected", "onClick"];
export default {
  __name: 'ReportStageTabs',
  props: {
    modelValue: {
      type: String,
      default: 'plan'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const options = [{
      value: 'plan',
      label: '计划'
    }, {
      value: 'summary',
      label: '总结'
    }];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, option => {
        return _createElementVNode("button", {
          key: option.value,
          type: "button",
          role: "tab",
          class: _normalizeClass(["min-w-[6.5rem] rounded-md px-4 py-2 text-sm font-medium transition-all duration-200", __props.modelValue === option.value ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700']),
          "aria-selected": __props.modelValue === option.value,
          onClick: $event => emit('update:modelValue', option.value)
        }, _toDisplayString(option.label), 11, _hoisted_2);
      }), 64))]);
    };
  }
};